var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"spinnerContainer",staticClass:"vld-parent"},[_c('UnifiedLayout',{attrs:{"isStockOnly":_vm.isStockOnly,"hasVent":_vm.hasVent,"hasValance":_vm.hasValance}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }